import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavDropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import allActions from '../../../../actions';

export const DropdownsMenuApplications = (props, context) => {
    
    const { user } = useSelector(state => state.user);
    const { applications } = useSelector(state => state.applications);

    const dispatch = useDispatch();
    
    const history = useHistory();
    // Variable used to force react route re-rendender change URI
    const [changeApp, setChangeApp] = useState(true);
    
    const goToApp = (accountId, id) => {
        // Alter uri for avoiding bug of react route v5, otherwise it doesn't re-render when only change a uri parameter)
        if (changeApp === true) {
            setChangeApp(false);
            history.push(`/accounts/${accountId}/apps/${id}`);
        } else {
            setChangeApp(true);
            history.push(`/accounts/${accountId}/appsBis/${id}`);
        }
    }

    const userAccountId = user.accounts[0].id;

    useEffect(() => {
        if (userAccountId !== null) {
            dispatch(allActions.applicationActions.getUserApplications(userAccountId));
        }    
    }, [])
           

    return (
    
        <NavDropdown id="basic-nav-dropdown" className="d-inline-block item-icon-wrapper" 
            title={ <><i className="material-icons">apps</i><span>{context.t("Applications")}</span></>}
            >
            { (applications && applications[0].id !== -1) ? 
                    applications.map( (app) => {
                        return (app.deleted_at === null)?(
                            <NavDropdown.Item   key={app.id}   
                                                title={ app.description }
                                                onClick={ () => {goToApp(user.accounts[0].id, app.id) }}
                                                >
                                {app.name}
                            </NavDropdown.Item>
                        ):(null)
                    })
                    :
                    ("")
            }
        </NavDropdown>

    )

};

DropdownsMenuApplications.contextTypes = {
    t: PropTypes.func
}

export default DropdownsMenuApplications;
